/**
 * Leitura de datas do broadcast de voz.
 *
 * O backend devolve as datas como string "naive" 'Y-m-d H:i:s' SEM offset, que
 * representam UTC. Aqui só garantimos que a string seja interpretada como UTC
 * (e não pelo fuso do navegador); a exibição em horário de Brasília fica com o
 * pipe `date` e a escrita com o `Date` do `app-window-datetime-picker` +
 * `Date.prototype.toJSON` global (app.module.ts).
 *
 * Os helpers de ESCRITA que viviam aqui (`backendToDatetimeLocal`,
 * `datetimeLocalToUtcIso`, `brasiliaDateToUtcIso`) saíram (review do MR !558,
 * ação 14): ficaram sem uso quando o criar/editar de Ligação passaram a usar o
 * `app-window-datetime-picker`, cujo CVA já entrega o `Date` com o instante
 * certo. `BRASILIA_TZ`/`BRASILIA_OFFSET`/`BRASILIA_OFFSET_MS` continuam —
 * removidos na branch de dev por estarem órfãos lá, mas `new-badge.ts` (fora
 * da M8, só existe neste worktree de HML) ainda os importa.
 */
export const BRASILIA_TZ = '-0300';
export const BRASILIA_OFFSET = '-03:00';
/** O mesmo deslocamento em milissegundos, para contas de "que dia é em Brasília". */
export const BRASILIA_OFFSET_MS = -3 * 60 * 60 * 1000;

/**
 * Normaliza a data vinda do backend para um ISO interpretável sem depender do
 * fuso do navegador. String naive (sem offset) é tratada como UTC; valores que
 * já trazem offset/Z são mantidos.
 */
export function backendToBrasiliaIso(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }
  if (/([zZ]|[+-]\d\d:?\d\d)$/.test(value)) {
    return value;
  }
  return value.replace(' ', 'T') + 'Z';
}
